module.exports = __webpack_public_path__ + "img/angular.811a50e0.png";